var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0833 16.9998C13.5 16.9998 13.0069 16.7984 12.6042 16.3957C12.2014 15.9929 12 15.4998 12 14.9165C12 14.3332 12.2014 13.8401 12.6042 13.4373C13.0069 13.0346 13.5 12.8332 14.0833 12.8332C14.6667 12.8332 15.1597 13.0346 15.5625 13.4373C15.9653 13.8401 16.1667 14.3332 16.1667 14.9165C16.1667 15.4998 15.9653 15.9929 15.5625 16.3957C15.1597 16.7984 14.6667 16.9998 14.0833 16.9998ZM6.16667 20.3332C5.70833 20.3332 5.31597 20.17 4.98958 19.8436C4.66319 19.5172 4.5 19.1248 4.5 18.6665V6.99984C4.5 6.5415 4.66319 6.14914 4.98958 5.82275C5.31597 5.49636 5.70833 5.33317 6.16667 5.33317H7V3.6665H8.66667V5.33317H15.3333V3.6665H17V5.33317H17.8333C18.2917 5.33317 18.684 5.49636 19.0104 5.82275C19.3368 6.14914 19.5 6.5415 19.5 6.99984V18.6665C19.5 19.1248 19.3368 19.5172 19.0104 19.8436C18.684 20.17 18.2917 20.3332 17.8333 20.3332H6.16667ZM6.16667 18.6665H17.8333V10.3332H6.16667V18.6665Z",
    fill: "#8C8594"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.7527a74daf1ab112d266d36bb27a7bd3.svg";
export { ForwardRef as ReactComponent };